import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IUpdatedPagesFiles } from "InterfacesTypes/interfaces";

export interface IUpdatedPagesFilesState {
  recentlyUpdatedFiles: IUpdatedPagesFiles[];
  loading: boolean;
  error: string | null;
}

const initialState: IUpdatedPagesFilesState = {
  recentlyUpdatedFiles: [],
  loading: false,
  error: null,
};

export const fetchRecentlyUpdatedFiles = createAction(
  "recentlyUpdatedFiles/fetchRecentlyUpdatedFiles"
);

export const recentlyUpdatedFilesSlice = createSlice({
  name: "recentlyUpdatedFiles",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IUpdatedPagesFiles[]>) {
      state.loading = false;
      state.recentlyUpdatedFiles = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setRecentlyUpdatedFiles(
      state,
      action: PayloadAction<IUpdatedPagesFiles[]>
    ) {
      state.recentlyUpdatedFiles = action.payload;
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  setRecentlyUpdatedFiles,
} = recentlyUpdatedFilesSlice.actions;

export const recentlyUpdatedFilesReducer = recentlyUpdatedFilesSlice.reducer;
